/*
 * A/B test "Build your own bundle" on the product page (snippets/ab-pdp-bundle.liquid).
 * Runs only in the variant (html.ab-pdp-bundle): builds the card from the devices in the config
 * under the buy button and adds the bundle to the cart with a shared _bundle_id, so
 * the "Bundle builder" discount function applies the tier discount. The free spray
 * chosen in the gift block goes along as _bundle_gift.
 */
(() => {
  const configElement = document.getElementById('AbPdpBundleConfig');
  const template = document.getElementById('AbPdpBundleTemplate');
  if (!configElement || !template) return;

  let CFG = JSON.parse(configElement.textContent);
  const TIERS = CFG.tiers;
  const MAX_ITEMS = 6;
  const VISIBLE = 6;
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const S = { products: {}, order: [], selected: [], built: false, expanded: false, root: null };

  const money = (cents) => {
    const value = cents / 100;
    try {
      return new Intl.NumberFormat(CFG.locale, {
        style: 'currency',
        currency: CFG.currency,
        minimumFractionDigits: value % 1 ? 2 : 0,
        maximumFractionDigits: 2,
      }).format(value).replace(/€\s+/, '€');
    } catch (error) {
      return '€' + value.toFixed(value % 1 ? 2 : 0).replace('.', ',');
    }
  };
  const el = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text != null) element.textContent = text;
    return element;
  };
  const fill = (text, n, d) => text.replace('[n]', n).replace('[d]', d);
  const units = (n) => n + ' ' + (n === 1 ? CFG.t.unitOne : CFG.t.unitMore);
  const tierFor = (n) => TIERS.reduce((tier, item) => (n >= item.count ? item : tier), null);
  const nextTier = (n) => TIERS.find((item) => n < item.count) || null;

  const mainEl = () => document.querySelector('main-product');
  const currentVariant = () => {
    const input = mainEl()?.querySelector('.main-product__form [name="id"]');
    return input ? parseInt(input.value, 10) : null;
  };

  // The free spray picked in the gift block (dropdown or tiles)
  const giftInfo = () => {
    const gifts = document.querySelector('[data-gift-products][data-selected-variant]');
    if (!gifts || !gifts.dataset.selectedVariant) return null;
    const variant = gifts.dataset.selectedVariant;
    const option = gifts.querySelector(`.main-product__gift-products-option[data-variant="${variant}"] .main-product__gift-products-item-title`);
    const tile = gifts.querySelector(`[data-variant="${variant}"][data-gift-title]`);
    const title = option?.textContent.trim() || tile?.dataset.giftTitle || '';
    return { id: parseInt(variant, 10), title };
  };

  /* Data: rendered by Liquid into the config, so the card builds without requests
     (and right away after the Standaard/PRO switch, from the new page's config) */

  const load = () => {
    if (S.built) return;

    CFG.products.forEach((product) => {
      let image = product.image || '';
      if (image.indexOf('//') === 0) image = 'https:' + image;
      S.products[product.handle] = { ...product, image };
      S.order.push(product.handle);
    });

    if (!S.products[CFG.current] || S.order.length < 2) return;
    S.built = true;
    build();
  };

  /* UI */

  const build = () => {
    const block = mainEl()?.querySelector('.main-product__block--buy_buttons');
    if (!block || block.querySelector('[data-ab-bb]')) return;

    const root = template.content.firstElementChild.cloneNode(true);
    S.root = root;

    const tiers = root.querySelector('[data-ab-bb-tiers]');
    TIERS.forEach((tier, index) => {
      const item = el('li', 'ab-bb__tier');
      item.dataset.count = tier.count;
      item.appendChild(el('span', 'ab-bb__tier-off', '−' + tier.off + '%'));
      const isLast = index === TIERS.length - 1;
      item.appendChild(el('span', 'ab-bb__tier-count', isLast ? tier.count + '+ ' + CFG.t.unitMore : units(tier.count)));
      tiers.appendChild(item);
    });

    const list = root.querySelector('[data-ab-bb-list]');
    S.order.forEach((handle, index) => {
      const product = S.products[handle];
      const locked = handle === CFG.current;
      const item = el(locked ? 'div' : 'button', 'ab-bb__item' + (locked ? ' is-locked is-selected' : ''));
      item.setAttribute('role', 'listitem');
      item.dataset.handle = handle;
      if (!locked) {
        item.type = 'button';
        item.setAttribute('aria-pressed', 'false');
        item.addEventListener('click', () => toggle(handle));
      }
      if (index >= VISIBLE) item.dataset.extra = '';

      if (product.image) {
        const image = el('img', 'ab-bb__img');
        image.src = product.image;
        image.alt = '';
        image.loading = 'lazy';
        image.width = 140;
        image.height = 140;
        item.appendChild(image);
      }
      if (product.preorder) item.appendChild(el('span', 'ab-bb__tag', CFG.t.preorder));
      item.appendChild(el('p', 'ab-bb__name', product.title));

      const price = el('p', 'ab-bb__price', money(product.price));
      if (product.compare) price.appendChild(el('s', '', money(product.compare)));
      item.appendChild(price);
      item.appendChild(el('span', 'ab-bb__toggle', locked ? '✓ ' + CFG.t.this : '+ ' + CFG.t.add));
      list.appendChild(item);
    });

    const more = root.querySelector('[data-ab-bb-more]');
    if (S.order.length > VISIBLE) {
      more.hidden = false;
      more.addEventListener('click', () => {
        S.expanded = !S.expanded;
        root.classList.toggle('is-expanded', S.expanded);
        more.textContent = S.expanded ? CFG.t.less : CFG.t.more;
        render();
      });
    }
    root.querySelector('[data-ab-bb-cta]').addEventListener('click', addBundle);

    block.appendChild(root);
    render();
  };

  const toggle = (handle) => {
    const index = S.selected.indexOf(handle);
    if (index > -1) S.selected.splice(index, 1);
    else if (S.selected.length + 1 < MAX_ITEMS) S.selected.push(handle);
    render();
  };

  const render = () => {
    const root = S.root;
    if (!root) return;

    const handles = [CFG.current].concat(S.selected);
    const n = handles.length;
    const tier = tierFor(n);
    const next = nextTier(n);
    const subtotal = handles.reduce((sum, handle) => sum + S.products[handle].price, 0);
    // Rounded per line, like the discount function
    const discount = tier
      ? handles.reduce((sum, handle) => sum + Math.round((S.products[handle].price * tier.off) / 100), 0)
      : 0;
    const gift = tier ? giftInfo() : null;

    root.querySelectorAll('.ab-bb__tier').forEach((item) => {
      const count = parseInt(item.dataset.count, 10);
      item.classList.toggle('is-reached', !!tier && tier.count === count);
      item.classList.toggle('is-next', !!next && next.count === count);
    });

    root.querySelectorAll('.ab-bb__item').forEach((item) => {
      const handle = item.dataset.handle;
      if (handle === CFG.current) return;
      const on = S.selected.indexOf(handle) > -1;
      item.classList.toggle('is-selected', on);
      item.setAttribute('aria-pressed', on ? 'true' : 'false');
      item.querySelector('.ab-bb__toggle').textContent = on ? '✓ ' + CFG.t.added : '+ ' + CFG.t.add;
      item.hidden = item.hasAttribute('data-extra') && !S.expanded && !on;
    });

    root.querySelector('[data-ab-bb-sub-row]').hidden = !tier;
    root.querySelector('[data-ab-bb-total-label]').textContent = tier ? '' : units(n);
    root.querySelector('[data-ab-bb-count]').textContent = units(n);
    root.querySelector('[data-ab-bb-sub]').textContent = money(subtotal);

    root.querySelector('[data-ab-bb-disc-row]').hidden = !tier;
    if (tier) {
      root.querySelector('[data-ab-bb-disc-label]').textContent = CFG.t.discount.replace('[d]', tier.off);
      root.querySelector('[data-ab-bb-disc]').textContent = '−' + money(discount);
    }

    const giftRow = root.querySelector('[data-ab-bb-gift]');
    giftRow.hidden = !(gift && gift.title);
    if (gift && gift.title) giftRow.textContent = CFG.t.gift.replace('[title]', gift.title);

    const total = root.querySelector('[data-ab-bb-total]');
    total.textContent = '';
    if (discount) total.appendChild(el('s', '', money(subtotal)));
    total.appendChild(document.createTextNode(money(subtotal - discount)));

    const save = root.querySelector('[data-ab-bb-save]');
    save.hidden = !discount;
    if (discount) save.textContent = CFG.t.save.replace('[price]', money(discount));

    root.querySelector('[data-ab-bb-nudge]').textContent = next
      ? fill(n < TIERS[0].count ? CFG.t.nudgeFirst : CFG.t.nudgeMore, next.count - n, next.off)
      : CFG.t.max;

    const cta = root.querySelector('[data-ab-bb-cta]');
    cta.disabled = !tier;
    cta.textContent = tier ? CFG.t.cta.replace('[price]', money(subtotal - discount)) : CFG.t.ctaLocked;
  };

  const addBundle = () => {
    const root = S.root;
    const handles = [CFG.current].concat(S.selected);
    if (!tierFor(handles.length) || root.classList.contains('is-loading')) return;

    const bundleId = 'b-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8);
    const items = handles.map((handle) => ({
      id: handle === CFG.current ? currentVariant() || S.products[handle].variant : S.products[handle].variant,
      quantity: 1,
      properties: { _bundle_id: bundleId },
    }));
    const gift = giftInfo();
    if (gift && gift.id) items.push({ id: gift.id, quantity: 1, properties: { _bundle_id: bundleId, _bundle_gift: 'true' } });

    // Upsells ticked in "Vaak samen gekocht" go along, outside the bundle (no _bundle_id)
    mainEl()?.querySelectorAll('.main-product__upsell-button.active').forEach((button) => {
      const id = parseInt(button.dataset.upsellVariant, 10);
      if (id) items.push({ id, quantity: parseInt(button.dataset.upsellQuantity, 10) || 1 });
    });

    root.classList.add('is-loading');
    root.querySelector('[data-ab-bb-error]').hidden = true;

    fetch(`${ROOT}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items, sections: ['cart-drawer'], sections_url: location.pathname }),
    })
      .then((response) => response.json())
      .then((response) => {
        if (!response.items) throw new Error(response.description || 'add failed');
        const drawer = document.querySelector('cart-drawer');
        if (drawer && response.sections && drawer.renderContent) {
          drawer.renderContent(response.sections);
          drawer.open();
        } else {
          location.href = `${ROOT}cart`;
        }
        S.selected = [];
        render();
      })
      .catch(() => {
        root.querySelector('[data-ab-bb-error]').hidden = false;
      })
      .finally(() => root.classList.remove('is-loading'));
  };

  /* Start */

  const init = () => {
    const main = mainEl();
    if (!main) return;

    // Load the devices only when the buy box is near the viewport
    const target = main.querySelector('.main-product__block--buy_buttons') || main;
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          observer.disconnect();
          load();
        }
      }, { rootMargin: '600px 0px' });
      observer.observe(target);
    } else {
      load();
    }

    // main-product.js can replace the product content (e.g. Standaard/PRO switch): put the card back
    new MutationObserver(() => {
      setTimeout(() => {
        if (S.built && S.root && !document.contains(S.root)) {
          S.root = null;
          build();
        }
      }, 50);
    }).observe(main, { childList: true });

    // Standaard/PRO switch: the config sits outside main-product, so take the new product's
    // config from the fetched page and rebuild the card for it (or drop it when it has none)
    document.addEventListener('main-product:changed', (event) => {
      const next = event.detail?.page?.getElementById('AbPdpBundleConfig');
      S.root?.remove();
      Object.assign(S, { products: {}, order: [], selected: [], built: false, expanded: false, root: null });
      if (!next) return;
      configElement.textContent = next.textContent;
      CFG = JSON.parse(next.textContent);
      load();
    });

    // Free spray changed in the gift block → update the summary line
    document.addEventListener('click', (event) => {
      if (event.target.closest?.('[data-gift-products]')) setTimeout(render, 80);
    });
  };

  // Intelligems may add the variant class after this script ran, so wait for it
  const start = () => {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  };
  const html = document.documentElement;
  if (html.classList.contains('ab-pdp-bundle')) {
    start();
  } else {
    const classObserver = new MutationObserver(() => {
      if (!html.classList.contains('ab-pdp-bundle')) return;
      classObserver.disconnect();
      start();
    });
    classObserver.observe(html, { attributes: true, attributeFilter: ['class'] });
  }
})();
